import { ContentWrapper, DataTable } from "@components/index";
import { Button, Modal, Pagination, Space, Spin, TableColumnsType, Tabs, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { get, remove } from "@services/api.service";
import { useNotification } from "@hooks/useNotification";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import { useMaskId } from "~/Hooks/useMaskId";
import { useHasAccess } from "@hooks/useHasAccess";
import { Icon } from "@iconify/react";
import { permissions } from "@utils/Roles";
import { getColoriezedValue, getColorizedValueDocuSign } from "~/Utils/getColorizedValue";
import { useQuery } from "~/Hooks/useQuery";
import { useAuth } from "@hooks/useAuth";
import { UserType } from "~/Utils";
import { debounce } from "lodash";
import { getFormattedDate, getKey, getUrlwithParams } from "@utils/CommonUtils";
import { FilterDropDown } from "@components/FilterDropDown/FilterDropDown";
import styles from "../Contract.module.scss";
import { SortOrder } from "antd/lib/table/interface";

export const Approver = () => {
  const [searchParams,setSearchParams]=useSearchParams()
  const [data, setData] = useState<any>([]);
  const { hasPermissions, hasRole } = useHasAccess();
  const { openToast } = useNotification();
  const [recordsPerPage, setRecordsPerPage] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setpage] = useState<number>(0);
  const [sortOrder, setSortOrder] = useState("desc");
  const [orderByName, setOrderByName] = useState("updatedOn");
  // const [division, setDivision] = useState("");
  const [searchString, setSearchString] = useState("");
  const [status, setStatus] = useState("");
  // const [subsidiary, setSubsidiary] = useState("");
  const [budgetValue, setBudgetValue] = useState("");
  const navigate = useNavigate();
  const [apiUrl, setApiUrl] = useState<any>("");
  const query = useQuery();
  const { user } = useAuth();
  const { mask } = useMaskId();
  const [clearSearch, setClearSearch] = useState(false);
  const [open, setOpen] = useState(false);
  const { openNotification } = useNotification();
  const [delteUniqueId, setDelteUniqueId] = useState<any>("");
  const [pageStart, setPageStart] = useState<number>(parseInt(query.get("page") || "0") || 0);
  const authority = query?.get("authority");
  useEffect(() => {
    if (hasRole(["SPA_ADMIN"])) {
      if (!query.get("authority")) {
        navigate(`/approver?authority=${"md/gceo"}`);
      }
    }
  }, []);

const subsidiary = searchParams.get("subsidiary")||'';
const division = searchParams.get("division")||'';

  const handleSearchChange = debounce((value: string, isLoading: boolean) => {
    setSearchString(value);
    setIsLoading(isLoading);
  }, 1000);

  const handleDelete = () => {
    setIsLoading(true);
    remove(`v1/spa/approver/delete-approver?uniqueId=${delteUniqueId}`)
      .then((res: any) => {
        getRecords(sortOrder, orderByName, searchString, pageStart);
        setIsLoading(false);
        openNotification({
          title: "Success",
          message: res.message,
          type: "success",
        });
        setOpen(false);
      })
      .catch((err: any) => {
        setIsLoading(false);
        openNotification({
          title: err,
          message: err.message,
          type: "error",
        });
        setOpen(false);
      });
  };

  const getFormattedDesignation = (designation: any) => {
 if (designation) {
      return <Typography.Text>{designation}</Typography.Text>;
    } else {
      return <Typography.Text disabled>-</Typography.Text>;
    }
  };

  const handleTableSort = (column: any, sortOrder: string, page: any) => {
    let order = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    getRecords(order, column.dataIndex, searchString, pageStart);
  };

  const getRecords = (sortOrder: string, orderByParam: string, searchString: any, currentPage?: number) => {
    setIsLoading(true);
    let url = `/v1/spa/approver/get-approver-list?page=${currentPage}&size=${recordsPerPage}&order=${sortOrder}&orderBy=${orderByParam}&authorityGroup=${authority}&subsidiary=${subsidiary}&division=${encodeURIComponent(division)}&budget=${encodeURIComponent(budgetValue)}&searchText=${encodeURIComponent(
      searchString
    )}`;
    setApiUrl(url);
    get(url)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          setTotalRecords(res.response.data.totalCount);
          let envelopes = res.response.data.records;
          setData(envelopes);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setData([]);
        openToast({
          content: "Getting Contracts failed",
          type: "error",
        });
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getRecords(sortOrder, orderByName, searchString, searchString.length > 0 ? 0 : pageStart);
  }, [searchString, query, status, subsidiary, pageStart, division,budgetValue]);

  const columns: TableColumnsType = [
    {
      title: "Designation",
      dataIndex: "designation",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "designation"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "designation"
          ? "descend"
          : undefined,
    },
    {
      title: "User Name",
      dataIndex: "userName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "userName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "userName"
          ? "descend"
          : undefined,
    },
    {
      title: "User Email ID",
      dataIndex: "userEmail",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "userEmail"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "userEmail"
          ? "descend"
          : undefined,
    },
    {
      title: "Subsidiary / Division",
      dataIndex: "subsidiary",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "subsidiary"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subsidiary"
          ? "descend"
          : undefined,
    },
    {
      title: "Cost Centre",
      dataIndex: "division",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "division"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "division"
          ? "descend"
          : undefined,
    },
    {
      title: "Last Modified Date",
      dataIndex: "updatedOn",
      render: (value: any, record: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "updatedOn"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "updatedOn"
          ? "descend"
          : undefined,
    },
    {
      title: "Last Updated By",
      dataIndex: "updatedBy",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },
  ];

  const reviewerColumn: TableColumnsType = [
    {
      title: "Designation",
      dataIndex: "designation",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "designation"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "designation"
          ? "descend"
          : undefined,
    },
    {
      title: "User Name",
      dataIndex: "userName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "userName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "userName"
          ? "descend"
          : undefined,
    },
    {
      title: "User Email ID",
      dataIndex: "userEmail",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "userEmail"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "userEmail"
          ? "descend"
          : undefined,
    },
    {
      title: "Subsidiary / Division",
      dataIndex: "subsidiary",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "subsidiary"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subsidiary"
          ? "descend"
          : undefined,
    },
    {
      title: "Cost Centre",
      dataIndex: "division",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "division"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "division"
          ? "descend"
          : undefined,
    },
    {
      title: "Last Modified Date",
      dataIndex: "updatedOn",
      render: (value: any, record: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "updatedOn"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "updatedOn"
          ? "descend"
          : undefined,
    },
    {
      title: "Last Updated By",
      dataIndex: "updatedBy",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },
  ];

  const menuClick = (key: string, record: { [key in string]: any }) => {
    if (key === "delete") {
      setOpen(true);
      setDelteUniqueId(record.uniqueId);
    }
    if (key === "edit") {
      navigate(`/approver/edit/?authority=${authority}&id=${record.uniqueId}`);
    }
  };

  const tableActions = {
    callback: menuClick,
    items: [
      {
        label: (
          <Typography.Text
            type="secondary"
            style={{ color: styles.primary }}
          >
            <Space>
              <Icon
                icon="akar-icons:edit"
                inline
                fontSize={16}
                style={{ color: styles.primary }}
              />
              Edit
            </Space>
          </Typography.Text>
        ),
        key: "edit",
      },
      {
        label: (
          <Typography.Text type="danger">
            <Space>
              <Icon
                icon="fluent:delete-48-regular"
                inline
                fontSize={16}
              />
              Delete
            </Space>
          </Typography.Text>
        ),
        key: "delete",
      },
    ],
  };

  const reviewerColumnReviewed: TableColumnsType = [
    {
      title: "Designation",
      dataIndex: "designation",
      render: (value: any) => getFormattedDesignation(value),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "designation"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "designation"
          ? "descend"
          : undefined,
    },
    ...(authority === "headOfSubsidiary"
    ? [
        {
          title: "Budget",
          dataIndex: "budget",
          render: (value: any) => value || <Typography.Text>NA</Typography.Text>,
          sorter: true,
          sortOrder:
          sortOrder === "asc" && orderByName === "designation"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "designation"
          ? "descend"
          :  undefined as SortOrder | undefined,
        },
      ]
    : []),
    {
      title: "User Name",
      dataIndex: "userName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "userName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "userName"
          ? "descend"
          : undefined,
    },
    {
      title: "User Email ID",
      dataIndex: "userEmail",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "userEmail"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "userEmail"
          ? "descend"
          : undefined,
    },
    {
      title: "Subsidiary / Division",
      dataIndex: "subsidiary",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "subsidiary"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subsidiary"
          ? "descend"
          : undefined,
    },
    {
      title: "Cost Centre",
      dataIndex: "division",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "division"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "division"
          ? "descend"
          : undefined,
    },
    {
      title: "Last Modified Date",
      dataIndex: "updatedOn",
      render: (value: any, record: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "updatedOn"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "updatedOn"
          ? "descend"
          : undefined,
    },
    {
      title: "Last Updated By",
      dataIndex: "updatedBy",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },
  ];

  const items = [
    {
      label: "MD/GCEO",
      key: "md/gceo",
      children: (
        <>
          <DataTable
            columns={reviewerColumn?.map((column) => ({
              ...column,
              onHeaderCell: (column: any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder, page ? page : 0);
                  }
                },
              }),
            }))}
            className="table-clickable"
            tableData={
              data
                ? data?.map((d: any, index: number) => {
                    return {
                      ...d,
                      key: getKey(page, index),
                    };
                  })
                : null
            }
            isLoading={false}
            tableActions={tableActions}
            exportFileName="Approvers"
            additionalCTA={
              <FilterDropDown
                setpage={setPageStart}
                clearFilter={clearSearch}
                viewDivisions={true}
                // setDivision={setDivision}
                viewStatus={true}
                viewBudget = {true}
                viewPaper
                viewSubsidiary={false}
                setStatus={setStatus}
                // setSubsidiary={setSubsidiary}
              />
            }
            ctaColSpan={17}
            onClick={(record) => {
              if (record) {
                navigate(`/approver?authority=md/gceo&page=${pageStart}`);
                navigate(`/approver/view/?id=${record.uniqueId}&view=${true}&authority=${authority}`);
              }
            }}
            totalRecords={totalRecords}
            exportApiUrl={apiUrl}
            recordsPerPage={recordsPerPage}
            inputDisable={isLoading}
            isPagination={true}
            isServerSearchApi={true}
            clearStringSearch={clearSearch}
            onSearchChange={handleSearchChange}
            searchPlaceholderText={"Search Approvers"}
            tabOffset={80}
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={pageStart}
              current={pageStart + 1}
              total={totalRecords}
              onChange={(page) => {
                const pageSize = 10;
                const startIndex = page - 1;
                setpage(page - 1);
                setPageStart(startIndex);
                getRecords(sortOrder, orderByName, searchString, startIndex);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ),
    },
    {
      label: "GCFO/CFO/CAO/COO",
      key: "gcfo/gcoo",
      children: (
        <>
          <DataTable
            columns={reviewerColumnReviewed?.map((column) => ({
              ...column,
              onHeaderCell: (column: any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder, page ? page : 0);
                  }
                },
              }),
            }))}
            className="table-clickable"
            onSearchChange={handleSearchChange}
            tableData={
              data
                ? data?.map((d: any, index: number) => {
                    return {
                      ...d,
                      key: getKey(page, index),
                    };
                  })
                : null
            }
            isLoading={false}
            tableActions={tableActions}
            inputDisable={isLoading}
            isServerSearchApi={true}
            exportFileName="Approvers"
            additionalCTA={
              <FilterDropDown
                setpage={setPageStart}
                clearFilter={clearSearch}
                viewDivisions={true}
                // setDivision={setDivision}
                viewBudget = {true}
                viewPaper
                viewStatus={true}
                viewSubsidiary={false}
                setStatus={setStatus}
                // setSubsidiary={setSubsidiary}
              />
            }
            ctaColSpan={17}
            onClick={(record) => {
              if (record) {
                navigate(`/approver?authority=gcfo/gcoo&page=${pageStart}`);
                navigate(`/approver/view/?id=${record.uniqueId}&view=${true}&authority=${authority}`);
              }
            }}
            searchPlaceholderText={"Search Approvers"}
            isPagination={true}
            totalRecords={totalRecords}
            exportApiUrl={apiUrl}
            clearStringSearch={clearSearch}
            recordsPerPage={recordsPerPage}
            tabOffset={80}
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={pageStart}
              total={totalRecords}
              current={pageStart + 1}
              onChange={(page) => {
                const pageSize = 10;
                const startIndex = page - 1;
                setpage(page - 1);
                setPageStart(startIndex);
                getRecords(sortOrder, orderByName, searchString, startIndex);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ),
    },
    {
      label: "Head of Subsidiary(MA Sepang/MASB/UTW/MAN)",
      key: "headOfSubsidiary",
      children: (
        <>
          <DataTable
            columns={reviewerColumnReviewed?.map((column) => ({
              ...column,
              onHeaderCell: (column: any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder, page ? page : 0);
                  }
                },
              }),
            }))}
            className="table-clickable"
            onSearchChange={handleSearchChange}
            tableData={
              data
                ? data?.map((d: any, index: number) => {
                    return {
                      ...d,
                      key: getKey(page, index),
                    };
                  })
                : null
            }
            isLoading={false}
            inputDisable={isLoading}
            tableActions={tableActions}
            isServerSearchApi={true}
            clearStringSearch={clearSearch}
            exportFileName="Approvers"
            additionalCTA={
              <FilterDropDown
                setpage={setPageStart}
                clearFilter={clearSearch}
                viewDivisions={true}
                // setDivision={setDivision}
                viewStatus={true}
                viewBudget = {true}
                viewPaper
                viewSubsidiary={false}
                setBudget={setBudgetValue}
                setStatus={setStatus}
                // setSubsidiary={setSubsidiary}
              />
            }
            ctaColSpan={17}
            onClick={(record) => {
              if (record) {
                navigate(`/approver?authority=headOfSubsidiary&page=${pageStart}`)
                navigate(`/approver/view/?id=${record.uniqueId}&view=${true}&authority=${authority}`);
              }
            }}
            searchPlaceholderText={"Search Approvers"}
            isPagination={true}
            totalRecords={totalRecords}
            exportApiUrl={apiUrl}
            recordsPerPage={recordsPerPage}
            tabOffset={80}
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={pageStart}
              total={totalRecords}
              current={pageStart + 1}
              onChange={(page) => {
                const pageSize = 10;
                const startIndex = page - 1;
                setpage(page - 1);
                setPageStart(startIndex);
                getRecords(sortOrder, orderByName, searchString, startIndex);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ),
    },
    {
      label: "Airport Procurement Committee (APC)",
      key: "airportManager",
      children: (
        <>
          <DataTable
            columns={reviewerColumnReviewed?.map((column) => ({
              ...column,
              onHeaderCell: (column: any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder, page ? page : 0);
                  }
                },
              }),
            }))}
            className="table-clickable"
            onSearchChange={handleSearchChange}
            tableData={
              data
                ? data?.map((d: any, index: number) => {
                    return {
                      ...d,
                      key: getKey(page, index),
                    };
                  })
                : null
            }
            isLoading={false}
            inputDisable={isLoading}
            tableActions={tableActions}
            isServerSearchApi={true}
            exportFileName="Approvers"
            additionalCTA={
              <FilterDropDown
                setpage={setPageStart}
                clearFilter={clearSearch}
                viewDivisions={true}
                // setDivision={setDivision}
                viewStatus={true}
                viewBudget = {true}
                viewPaper
                viewSubsidiary={false}
                setStatus={setStatus}
                // setSubsidiary={setSubsidiary}
              />
            }
            ctaColSpan={17}
            onClick={(record) =>{
              if (record) {
                navigate(`/approver?authority=airportManager&page=${pageStart}`)
                navigate(`/approver/view/?id=${record.uniqueId}&view=${true}&authority=${authority}`);
              }
            }
              }
            searchPlaceholderText={"Search Approvers"}
            isPagination={true}
            totalRecords={totalRecords}
            exportApiUrl={apiUrl}
            recordsPerPage={recordsPerPage}
            tabOffset={80}
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={pageStart}
              total={totalRecords}
              current={pageStart + 1}
              onChange={(page) => {
                const pageSize = 10;
                const startIndex = page - 1;
                setpage(page - 1);
                setPageStart(startIndex);
                getRecords(sortOrder, orderByName, searchString, startIndex);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ),
    },
  ];

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setClearSearch(false);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [isLoading]);


  const id = data.map((envelope: any) => envelope.uniqueId);
  return (
    <ContentWrapper
      title={"Approvers"}
      actionItems={
        <Button
          type="primary"
          onClick={() => navigate(`/approver/add?authority=${authority}`)}
        >
          <Space>
            <Icon
              icon="akar-icons:plus"
              inline
            />
            Add
          </Space>
        </Button>
      }
    >
      {isLoading && (
        <div className="loadingOverlay">
          <Space size="middle">
            <Spin size="large" />
          </Space>
        </div>
      )}
      {hasRole(["SPA_ADMIN"]) ? (
        <Tabs
          activeKey={query?.get("authority") || ""}
          items={items}
          onChange={(activeKey) => {
            setPageStart(0);
            setpage(0);
            setStatus("");
            // setSubsidiary("");
            setSearchString("");
            setClearSearch(true);
            navigate(`/approver?authority=${activeKey}`);
          }}
        ></Tabs>
      ) : (
        <div>
          <DataTable
            columns={columns?.map((column) => ({
              ...column,
              onHeaderCell: (column: any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder, page ? page : 0);
                  }
                },
              }),
            }))}
            className="table-clickable"
            tableData={
              data
                ? data?.map((d: any, index: number) => {
                    return {
                      ...d,
                      key: getKey(page, index),
                    };
                  })
                : null
            }
            isLoading={false}
            exportFileName="Approvers"
            additionalCTA={
              <FilterDropDown
                setpage={setPageStart}
                clearFilter={clearSearch}
                viewDivisions={true}
                viewStatus={true}
                viewBudget = {true}
                viewPaper={true}
                viewSubsidiary={true}
                setStatus={setStatus}
                // setSubsidiary={setSubsidiary}
              />
            }
            onClick={(record) => {
              getUrlwithParams();
              // navigate(`/contracts-review/view/${record.envelopeId}`);
            }}
            isServerSearchApi={true}
            totalRecords={totalRecords}
            exportApiUrl={apiUrl}
            recordsPerPage={recordsPerPage}
            isPagination={true}
            onSearchChange={handleSearchChange}
            searchPlaceholderText={"Search Approvers"}
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={1}
              total={totalRecords}
              current={page + 1}
              onChange={(page) => {
                const pageSize = 10;
                const startIndex = page - 1;
                setpage(page - 1);
                setPageStart(startIndex);
                getRecords(sortOrder, orderByName, searchString, startIndex);
              }}
              showSizeChanger={false}
            />
          </div>
        </div>
      )}
      <Modal
        open={open}
        title={"Delete Approvers"}
        centered
        closable={false}
        onCancel={() => setOpen(false)}
        maskClosable={false}
        okText={"Delete"}
        onOk={handleDelete}
        okButtonProps={{
          loading: isLoading,
        }}
      >
        <Typography.Text>Are you sure you want to delete this Approver? </Typography.Text>
      </Modal>
    </ContentWrapper>
  );
};
